/** 积分 */
export const integral = [
  /** S 积分 */
  {
    name: 'integralTaskDetail', // 积分任务详情
    isMock: false,
  },
  {
    name: 'integralGetAiEquityList', // 权益卡列表
    isMock: false,
  },
  {
    name: 'receiveIntegral', // 领取积分
    isMock: false,
  },
  {
    name: 'getIntegralInfo', // 积分记录
    isMock: false,
  },
  /** E 积分  */
  /** S 订单 */
  {
    name: 'getPayTypeList', // 获取支持的支付方式
    isMock: false,
  },
  {
    name: 'rechargeBalance', // 积分充值预结算
    isMock: false,
  },
  {
    name: 'getRechargeResult', // 积分订单结果
    isMock: false,
  },
  {
    name: 'getRechargePoint', // 获取充值金额对应额积分
    isMock: false,
  },
  /** E 订单  */
]
